import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { UiContext } from 'uiContext';
import { FerecastProps } from 'components/forecast/forecastTypes';
import map from 'lodash/map';
import ForecastItemMobile from 'components/forecast/forecastItem/forecastItemMobile';

export default function ForecastMobile({ items }: FerecastProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        'display': 'flex',
        'flexWrap': 'wrap',
        'gap': sp.s15,
        '& > *': {
          flexGrow: 1,
          flexBasis: 0,
        },
      }}
    >
      {map(items, (item, i) => (
        <ForecastItemMobile key={i} {...item}></ForecastItemMobile>
      ))}
    </Box>
  );
}
